import { Feather, ShieldCheck, TrendingDown } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const benefits = [
  {
    icon: Feather,
    title: "Less Shaving",
    copy: "Reduce the need for frequent shaving.",
  },
  {
    icon: ShieldCheck,
    title: "Fewer Ingrown-Hair / Razor-Bump Concerns",
    copy: "Reducing repeated shaving may help reduce irritation associated with shaving in suitable patients.",
  },
  {
    icon: TrendingDown,
    title: "Long-Term Reduction",
    copy: "A course of treatments can provide significant, long-lasting reduction in unwanted hair, although maintenance may be needed.",
  },
];

export const WhyLaser = () => (
  <section data-testid="why-laser-section" className="py-24 md:py-36">
    <div className="max-w-7xl mx-auto px-5 md:px-10">
      <SectionHead
        index="03"
        eyebrow="Why Laser Hair Reduction?"
        title="More Than Just Removing Hair — Reduce the Repetition."
        copy="Laser hair reduction targets pigment in the hair follicle. With a series of treatments, hair growth can be progressively reduced, helping you spend less time shaving or waxing."
      />
      <div className="mt-14 grid md:grid-cols-3 gap-5">
        {benefits.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.08}>
            <div
              data-testid={`benefit-card-${i + 1}`}
              className="group h-full rounded-3xl border border-champagne/60 bg-white/60 p-9 transition-[background-color,transform] duration-500 hover:-translate-y-1.5 hover:bg-white"
            >
              <span className="font-mono text-xs text-champagne-dark tracking-[0.3em]">0{i + 1}</span>
              <b.icon className="mt-6 w-8 h-8 text-teal transition-transform duration-500 group-hover:scale-110" strokeWidth={1.4} />
              <h3 className="mt-6 font-display text-xl md:text-2xl font-medium tracking-tight text-ink leading-snug">{b.title}</h3>
              <p className="mt-3 text-sm font-light leading-relaxed text-ink/60">{b.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
